import instance from "../config/axios";
import { url, base_apis } from "../config/url";


export const getSubscriptionList = ( data) => {
  return instance.post(`${base_apis.subscriptionTypeList}`, data).then((res) => {
    return res;
  });
};


export const payUHashSubscription = (data) => {
  return instance.post(`${base_apis.payUHashSubcription}`, data).then((res) => {
    return res;
  });
};

export const createPayPayment = (data) => {
  return instance.post(`${base_apis.payUCreateSubcription}`, data).then((res) => {
    return res;
  });
};


export const getUserSubscriptionDetails = (data) => {
  return instance.post(`${base_apis.userSubscriptionDetails}/${data}`).then((res) => {
    return res;
  });
};